const basicsTemplates = {
  hero: ["default", "content", "minimal", "without-title", "2-cols"],
  carousel: ["simple", "details", "link", "produits"],
  "2-col": ["without-ss", "without-ss-inverse", "2-images", "contact", "partners"],
  calltoaction: ["contact", "newsletter", "2-col"],
  grid: [
    "cards",
    "categorie",
    "cards-without-image",
    "without-title",
    "images",
  ],
  faq: ["accordeon", "list"],
};

export const templateTypeVariants = {
  default: {
    ...basicsTemplates,
  },

  detail: {
    ...basicsTemplates,
  },

  avec_sidebar_rdv: {
    hero: ["minimal", "split"],
    calltoaction: ["contact", "newsletter"],
  },
};
